import { render, staticRenderFns } from "./EditLeaverRule.vue?vue&type=template&id=a4c15d78&"
import script from "./EditLeaverRule.vue?vue&type=script&lang=ts&"
export * from "./EditLeaverRule.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports